<template>
  <div class="mb-3">
    <v-card dark class="elevation-5" style="width: 250px">
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-title
            style="text-align: center; font-size: 20px; color: white"
            >Manager Management</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-list class="py-0" style="overflow: hidden">
        <v-list-group
          v-for="item in filteredSidebar"
          v-model="item.active"
          :key="item.title"
          :prepend-icon="item.action"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <div>
                {{ item.title }}
                <span
                  v-if="countNumber > 0 && item.title == 'Bank.'"
                  class="circle"
                  >{{ countNumber }}</span
                >
                <span
                  v-if="item.title == 'Money' && fetchCountRequest > 0"
                  class="circle"
                  >{{ fetchCountRequest }}</span
                >
              </div>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="subItem in filterSubSidebar(item)"
            :key="subItem.title"
            :to="subItem.url"
          >
            <v-list-tile-content>
              <div>
                {{ subItem.title }}
                <span
                  class="circle"
                  v-if="countNumber > 0 && subItem.title == 'Bank Approve'"
                >
                  {{ countNumber }}
                </span>
              </div>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      items: [
        {
          action: "emoji_symbols",
          permission_name: "approve_list",
          title: "Commission",
          items: [
            {
              title: "Area",
              permission_name: "contact_approve",
              url: "/weserve_admin_login/-/CommissionArea",
            },
            {
              title: "Withdraw",
              permission_name: "document_approve",
              url: "/weserve_admin_login/-/Withdraw",
            },
          ],
        },
        {
          action: "account_balance",
          permission_name: "notification",
          title: "Bank.",
          items: [
            {
              title: "Bank List",
              permission_name: "bank list",
              url: "/weserve_admin_login/-/BankList",
            },
            {
              title: "Bank List",
              permission_name: "merchant_news",
              url: "/weserve_admin_login/-/BankList",
            },
            {
              title: "Bank Approve",
              permission_name: "merchant_news",
              url: "/weserve_admin_login/-/Bankapprove",
            },
          ],
        },
        {
          action: "money",
          permission_name: "approve_list",
          title: "Money",
          items: [
            {
              title: "Request cash",
              permission_name: "contact_approve",
              url: "/weserve_admin_login/:province/money",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
      countNumber: (state) => state.banklist.getCountApprove,
      fetchCountRequest: (state) => state.cashRequest.fetchCountRequest,
    }),
    filteredSidebar() {
      return this.items.filter((val) => {
        for (let val2 in this.permission.main_menu.merchant_manage) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
  },
  methods: {
    filterSubSidebar(item) {
      return item.items.filter((val) => {
        for (let val2 in this.permission.main_menu.merchant_manage[
          item.permission_name
        ]) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
  },
};
</script>
<style scoped>
.circle {
  height: 25px;
  width: 25px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
}
</style>
